import { SvgIconProps } from './types';

export function Facebook({ svgProps, pathProps }: SvgIconProps) {
  return (
    <svg viewBox={`0 0 9 24`} height={24} width={24} {...svgProps}>
      <path
        {...pathProps}
        d="M3.15201 19.5999H6.66801V10.8399H9.60801L10.052 7.4319H6.66801V5.2479C6.66801 4.2639 6.94401 3.5919 8.36001 3.5919H10.172V0.531902C9.86001 0.495902 8.79201 0.399902 7.54401 0.399902C4.92801 0.399902 3.15201 1.9959 3.15201 4.9119V7.4319H0.200012V10.8399H3.15201V19.5999Z"
      />
    </svg>
  );
}
export function Instagram({
  svgProps,
  pathProps,
  className,
  stroke,
}: SvgIconProps) {
  return (
    <svg
      viewBox={`0 0 21 24`}
      height={24}
      width={24}
      {...svgProps}
      className={className}
    >
      <path
        {...pathProps}
        fill={stroke}
        d="M6.465 0.265707C7.638 0.211707 8.012 0.199707 11 0.199707C13.988 0.199707 14.362 0.212707 15.534 0.265707C16.706 0.318707 17.506 0.505707 18.206 0.776707C18.939 1.05371 19.604 1.48671 20.154 2.04671C20.714 2.59571 21.146 3.25971 21.422 3.99371C21.694 4.69371 21.88 5.49371 21.934 6.66371C21.988 7.83871 22 8.21271 22 11.1997C22 14.1877 21.987 14.5617 21.934 15.7347C21.881 16.9047 21.694 17.7047 21.422 18.4047C21.146 19.1388 20.7133 19.8039 20.154 20.3537C19.604 20.9137 18.939 21.3457 18.206 21.6217C17.506 21.8937 16.706 22.0797 15.536 22.1337C14.362 22.1877 13.988 22.1997 11 22.1997C8.012 22.1997 7.638 22.1867 6.465 22.1337C5.295 22.0807 4.495 21.8937 3.795 21.6217C3.06092 21.3457 2.39582 20.913 1.846 20.3537C1.28638 19.8044 0.853315 19.1396 0.577 18.4057C0.306 17.7057 0.12 16.9057 0.066 15.7357C0.012 14.5607 0 14.1867 0 11.1997C0 8.21171 0.013 7.83771 0.066 6.66571C0.119 5.49371 0.306 4.69371 0.577 3.99371C0.853723 3.25979 1.28712 2.59502 1.847 2.04571C2.39604 1.48621 3.06047 1.05315 3.794 0.776707C4.494 0.505707 5.294 0.319707 6.464 0.265707H6.465ZM15.445 2.24571C14.285 2.19271 13.937 2.18171 11 2.18171C8.063 2.18171 7.715 2.19271 6.555 2.24571C5.482 2.29471 4.9 2.47371 4.512 2.62471C3.999 2.82471 3.632 3.06171 3.247 3.44671C2.88205 3.80176 2.60118 4.23399 2.425 4.71171C2.274 5.09971 2.095 5.68171 2.046 6.75471C1.993 7.91471 1.982 8.26271 1.982 11.1997C1.982 14.1367 1.993 14.4847 2.046 15.6447C2.095 16.7177 2.274 17.2997 2.425 17.6877C2.601 18.1647 2.882 18.5977 3.247 18.9527C3.602 19.3177 4.035 19.5987 4.512 19.7747C4.9 19.9257 5.482 20.1047 6.555 20.1537C7.715 20.2067 8.062 20.2177 11 20.2177C13.938 20.2177 14.285 20.2067 15.445 20.1537C16.518 20.1047 17.1 19.9257 17.488 19.7747C18.001 19.5747 18.368 19.3377 18.753 18.9527C19.118 18.5977 19.399 18.1647 19.575 17.6877C19.726 17.2997 19.905 16.7177 19.954 15.6447C20.007 14.4847 20.018 14.1367 20.018 11.1997C20.018 8.26271 20.007 7.91471 19.954 6.75471C19.905 5.68171 19.726 5.09971 19.575 4.71171C19.375 4.19871 19.138 3.83171 18.753 3.44671C18.3979 3.08178 17.9657 2.80092 17.488 2.62471C17.1 2.47371 16.518 2.29471 15.445 2.24571ZM9.595 14.5907C10.3797 14.9173 11.2534 14.9614 12.0669 14.7154C12.8805 14.4694 13.5834 13.9486 14.0556 13.242C14.5278 12.5353 14.7401 11.6866 14.656 10.8408C14.572 9.99505 14.197 9.20468 13.595 8.60471C13.2112 8.22118 12.7472 7.92752 12.2363 7.74485C11.7255 7.56219 11.1804 7.49507 10.6405 7.54832C10.1006 7.60158 9.57915 7.77388 9.1138 8.05284C8.64845 8.33179 8.25074 8.71045 7.9493 9.16156C7.64786 9.61267 7.45019 10.125 7.37052 10.6617C7.29084 11.1983 7.33115 11.746 7.48854 12.2652C7.64593 12.7844 7.91648 13.2623 8.28072 13.6644C8.64496 14.0665 9.09382 14.3829 9.595 14.5907ZM7.002 7.20171C7.52702 6.67668 8.15032 6.26021 8.8363 5.97607C9.52228 5.69193 10.2575 5.54568 11 5.54568C11.7425 5.54568 12.4777 5.69193 13.1637 5.97607C13.8497 6.26021 14.473 6.67668 14.998 7.20171C15.523 7.72673 15.9395 8.35003 16.2236 9.03601C16.5078 9.72198 16.654 10.4572 16.654 11.1997C16.654 11.9422 16.5078 12.6774 16.2236 13.3634C15.9395 14.0494 15.523 14.6727 14.998 15.1977C13.9377 16.258 12.4995 16.8537 11 16.8537C9.50046 16.8537 8.06234 16.258 7.002 15.1977C5.94166 14.1374 5.34597 12.6992 5.34597 11.1997C5.34597 9.70017 5.94166 8.26204 7.002 7.20171ZM17.908 6.38771C18.0381 6.26498 18.1423 6.11739 18.2143 5.95368C18.2863 5.78997 18.3248 5.61348 18.3274 5.43464C18.33 5.2558 18.2967 5.07825 18.2295 4.91252C18.1622 4.74678 18.0624 4.59622 17.936 4.46975C17.8095 4.34327 17.6589 4.24346 17.4932 4.17622C17.3275 4.10898 17.1499 4.07568 16.9711 4.07829C16.7922 4.0809 16.6157 4.11936 16.452 4.1914C16.2883 4.26345 16.1407 4.3676 16.018 4.49771C15.7793 4.75074 15.6486 5.08683 15.6537 5.43464C15.6588 5.78245 15.7992 6.11459 16.0452 6.36055C16.2911 6.60651 16.6233 6.74694 16.9711 6.75201C17.3189 6.75708 17.655 6.6264 17.908 6.38771Z"
      />
    </svg>
  );
}
export function Youtube({ svgProps, pathProps }: SvgIconProps) {
  return (
    <svg viewBox={`0 0 24 18`} height={18} width={24} {...svgProps}>
      <path
        {...pathProps}
        d="M23.5 3.50708C23.3641 3.02231 23.0994 2.58342 22.734 2.23708C22.3583 1.88008 21.8978 1.62471 21.396 1.49508C19.518 1.00008 11.994 1.00008 11.994 1.00008C8.85734 0.964389 5.72144 1.12135 2.60401 1.47008C2.1022 1.60929 1.64257 1.87036 1.26601 2.23008C0.896007 2.58608 0.628007 3.02508 0.488007 3.50608C0.1517 5.31782 -0.0117011 7.15742 6.83166e-06 9.00008C-0.0119932 10.8411 0.151007 12.6801 0.488007 14.4941C0.625007 14.9731 0.892007 15.4101 1.26301 15.7631C1.63401 16.1161 2.09601 16.3711 2.60401 16.5061C4.50701 17.0001 11.994 17.0001 11.994 17.0001C15.1347 17.0358 18.2746 16.8789 21.396 16.5301C21.8978 16.4004 22.3583 16.1451 22.734 15.7881C23.0993 15.4418 23.3637 15.0029 23.499 14.5181C23.8441 12.707 24.0119 10.8667 24 9.02308C24.026 7.17168 23.8584 5.32264 23.5 3.50608V3.50708ZM9.60201 12.4241V5.57708L15.862 9.00108L9.60201 12.4241Z"
      />
    </svg>
  );
}
export function Pinterest({ svgProps, pathProps }: SvgIconProps) {
  return (
    <svg viewBox={`0 0 24 24`} height={24} width={24} {...svgProps}>
      <path
        {...pathProps}
        d="M0 12C0 17.123 3.211 21.497 7.73 23.218C7.62 22.281 7.503 20.736 7.755 19.652C7.972 18.72 9.156 13.714 9.156 13.714C9.156 13.714 8.799 12.999 8.799 11.94C8.799 10.28 9.761 9.04 10.96 9.04C11.98 9.04 12.472 9.805 12.472 10.722C12.472 11.747 11.819 13.279 11.482 14.7C11.201 15.889 12.079 16.859 13.251 16.859C15.374 16.859 17.007 14.62 17.007 11.388C17.007 8.527 14.951 6.528 12.016 6.528C8.618 6.528 6.623 9.077 6.623 11.712C6.623 12.739 7.018 13.839 7.512 14.438C7.55412 14.4832 7.58387 14.5386 7.59841 14.5986C7.61295 14.6587 7.61177 14.7215 7.595 14.781C7.504 15.159 7.302 15.97 7.263 16.136C7.21 16.354 7.09 16.401 6.863 16.295C5.371 15.601 4.439 13.42 4.439 11.668C4.439 7.899 7.176 4.439 12.331 4.439C16.475 4.439 19.696 7.392 19.696 11.338C19.696 15.455 17.101 18.769 13.497 18.769C12.286 18.769 11.149 18.139 10.759 17.396C10.759 17.396 10.16 19.678 10.015 20.236C9.733 21.32 8.951 22.692 8.466 23.471C9.584 23.815 10.77 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0C5.373 0 0 5.373 0 12Z"
      />
    </svg>
  );
}
export function FacebookBrand() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M22 12C22 6.47719 17.5228 2 12 2C6.47719 2 2 6.47711 2 12C2 16.9913 5.65687 21.1284 10.4375 21.8785V14.8906H7.89844V12H10.4375V9.79688C10.4375 7.29063 11.9305 5.90625 14.2146 5.90625C15.3088 5.90625 16.4531 6.10156 16.4531 6.10156V8.5625H15.1922C13.9498 8.5625 13.5625 9.33336 13.5625 10.1242V12H16.3359L15.8926 14.8906H13.5625V21.8785C18.3431 21.1284 22 16.9913 22 12Z"
        fill="#1877F2"
      />
      <path
        d="M15.8926 14.8906L16.3359 12H13.5625V10.1242C13.5625 9.33328 13.9499 8.5625 15.1922 8.5625H16.4531V6.10156C16.4531 6.10156 15.3088 5.90625 14.2146 5.90625C11.9305 5.90625 10.4375 7.29063 10.4375 9.79688V12H7.89844V14.8906H10.4375V21.8785C10.9544 21.9595 11.4768 22.0001 12 22C12.5232 22.0002 13.0456 21.9595 13.5625 21.8785V14.8906H15.8926Z"
        fill="white"
      />
    </svg>
  );
}

export function Email({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.8 5H19.2C20.19 5 21 5.7875 21 6.75V17.25C21 18.2125 20.19 19 19.2 19H4.8C3.81 19 3 18.2125 3 17.25V6.75C3 5.7875 3.81 5 4.8 5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M20.5 6.5L12 12L3.5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}

export function MessengerBrand() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.36671 2 2 6.12641 2 11.7C2 14.6154 3.1948 17.1346 5.14057 18.8746C5.30391 19.0208 5.40251 19.2256 5.40921 19.4448L5.46367 21.2236C5.48107 21.791 6.06715 22.1602 6.58635 21.931L8.57121 21.0548C8.73947 20.9806 8.92801 20.9668 9.10531 21.0156C10.0174 21.2664 10.9882 21.4 12 21.4C17.6333 21.4 22 17.2736 22 11.7C22 6.12641 17.6333 2 12 2Z"
        fill="url(#paint0_radial_353_1333)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99517 14.5367L8.93268 9.87632C9.39994 9.13492 10.4005 8.95032 11.1016 9.47612L13.438 11.2284C13.6523 11.3892 13.9473 11.3883 14.1607 11.2263L17.3161 8.83162C17.7373 8.51202 18.287 9.01602 18.0052 9.46328L15.0676 14.1237C14.6003 14.8651 13.5997 15.0497 12.8987 14.5239L10.5623 12.7716C10.3479 12.6108 10.053 12.6117 9.83954 12.7737L6.68417 15.1684C6.26303 15.488 5.71327 14.984 5.99517 14.5367Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_353_1333"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.84949 21.893) scale(21.792 21.7919)"
        >
          <stop stopColor="#0099FF" />
          <stop offset="0.609754" stopColor="#A033FF" />
          <stop offset="0.934823" stopColor="#FF5280" />
          <stop offset="1" stopColor="#FF7061" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function TwitterBrand() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
        fill="#1B9DF0"
      />
      <path
        d="M9.98709 17.8019C14.8656 17.8019 17.5331 13.7594 17.5331 10.2559C17.5331 10.1404 17.5331 10.0249 17.5276 9.91488C18.0446 9.54088 18.4956 9.07338 18.8531 8.53988C18.3801 8.74888 17.8686 8.89187 17.3296 8.95787C17.8796 8.62787 18.2976 8.11088 18.4956 7.48937C17.9841 7.79188 17.4176 8.01187 16.8126 8.13287C16.3286 7.61587 15.6411 7.29688 14.8766 7.29688C13.4136 7.29688 12.2256 8.48487 12.2256 9.94787C12.2256 10.1569 12.2476 10.3604 12.2971 10.5529C10.0916 10.4429 8.13909 9.38688 6.83009 7.78088C6.60459 8.17138 6.47259 8.62787 6.47259 9.11187C6.47259 10.0304 6.94009 10.8444 7.65509 11.3174C7.22059 11.3064 6.81359 11.1854 6.45609 10.9874C6.45609 10.9984 6.45609 11.0094 6.45609 11.0204C6.45609 12.3074 7.36909 13.3744 8.58459 13.6219C8.36459 13.6824 8.12809 13.7154 7.88609 13.7154C7.71559 13.7154 7.55059 13.6989 7.38559 13.6659C7.72109 14.7219 8.70009 15.4864 9.86059 15.5084C8.95309 16.2179 7.80909 16.6414 6.56609 16.6414C6.35159 16.6414 6.14259 16.6304 5.93359 16.6029C7.09409 17.3619 8.49109 17.8019 9.98709 17.8019Z"
        fill="white"
      />
    </svg>
  );
}

export function GoogleBrand() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
        fill="#FFC107"
      />
      <path
        d="M3.15234 7.3455L6.43784 9.755C7.32684 7.554 9.47984 6 11.9993 6C13.5288 6 14.9203 6.577 15.9798 7.5195L18.8083 4.691C17.0223 3.0265 14.6333 2 11.9993 2C8.15834 2 4.82734 4.1685 3.15234 7.3455Z"
        fill="#FF3D00"
      />
      <path
        d="M12.0002 22.0003C14.5832 22.0003 16.9302 21.0118 18.7047 19.4043L15.6097 16.7853C14.5719 17.5745 13.3039 18.0014 12.0002 18.0003C9.39916 18.0003 7.19066 16.3418 6.35866 14.0273L3.09766 16.5398C4.75266 19.7783 8.11366 22.0003 12.0002 22.0003Z"
        fill="#4CAF50"
      />
      <path
        d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
        fill="#1976D2"
      />
    </svg>
  );
}

export function WhatsAppBrand() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="#25D366"
        d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.1.824zm-3.423-14.416c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm.029 18.88c-1.161 0-2.305-.292-3.318-.844l-3.677.964.984-3.595c-.607-1.052-.927-2.246-.926-3.468.001-3.825 3.113-6.937 6.937-6.937 1.856.001 3.598.723 4.907 2.034 1.31 1.311 2.031 3.054 2.03 4.908-.001 3.825-3.113 6.938-6.937 6.938z"
      />
    </svg>
  );
}

export function Tiktok({ svgProps, pathProps }: SvgIconProps) {
  return (
    <svg
      viewBox={`0 0 24 24`}
      height={24}
      width={24}
      {...svgProps}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        {...pathProps}
        d="M16.1012 5.135C15.9746 5.06954 15.8514 4.99778 15.732 4.92C15.3851 4.6906 15.0669 4.42033 14.7845 4.115C14.077 3.30583 13.8128 2.485 13.7162 1.91083H13.7195C13.6387 1.43333 13.672 1.125 13.6778 1.125H10.457V13.5775C10.457 13.7442 10.457 13.91 10.4503 14.0733C10.4503 14.0933 10.4478 14.1117 10.447 14.1342C10.447 14.1425 10.447 14.1525 10.4445 14.1617V14.1692C10.4107 14.6159 10.2676 15.0474 10.0278 15.4258C9.78807 15.8042 9.45897 16.1178 9.06951 16.3392C8.6632 16.5703 8.20364 16.6915 7.73618 16.6908C6.23618 16.6908 5.01951 15.4675 5.01951 13.9567C5.01951 12.445 6.23618 11.2217 7.73618 11.2217C8.02035 11.2217 8.30285 11.2667 8.57285 11.355L8.57701 8.075C7.75702 7.96921 6.92401 8.03455 6.13055 8.26691C5.33708 8.49927 4.6004 8.8936 3.96701 9.425C3.41189 9.90712 2.94517 10.4824 2.58785 11.125C2.45201 11.3592 1.93868 12.3017 1.87701 13.83C1.83785 14.6967 2.09868 15.5967 2.22285 15.9675V15.9758C2.30035 16.1942 2.60368 16.9408 3.09701 17.57C3.49484 18.075 3.96489 18.5187 4.49201 18.8867V18.8783L4.49951 18.8867C6.05785 19.945 7.78701 19.8758 7.78701 19.8758C8.08618 19.8633 9.08868 19.8758 10.227 19.3367C11.4895 18.7383 12.2078 17.8475 12.2078 17.8475C12.6671 17.3151 13.0323 16.7084 13.2878 16.0533C13.5795 15.2867 13.6762 14.3683 13.6762 14.0017V7.39417C13.7153 7.4175 14.2362 7.76167 14.2362 7.76167C14.2362 7.76167 14.9862 8.2425 16.1553 8.555C16.9937 8.7775 18.1245 8.825 18.1245 8.825V5.6275C17.7287 5.67083 16.9245 5.54583 16.1003 5.13583L16.1012 5.135Z"
      />
    </svg>
  );
}
